import { render, staticRenderFns } from "./UserInjuryTable.vue?vue&type=template&id=2bc7eda9&"
import script from "./UserInjuryTable.vue?vue&type=script&lang=js&"
export * from "./UserInjuryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports